import { render, staticRenderFns } from "./current-address.vue?vue&type=template&id=f8ad7cc2&"
import script from "./current-address.vue?vue&type=script&lang=js&"
export * from "./current-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports